export function handleResponse(response) {
  if (Array.isArray(response)) {
    return response.map(({ data } = {}) => {
      if (typeof data?.values !== "function" && data?.values) {
        return data?.values;
      }

      return data;
    });
  }

  if (typeof response?.data?.values !== "function" && response?.data?.values) {
    return response?.data?.values;
  }

  return response?.data;
}

export function handleError(axiosError) {
  const { status, data } = axiosError?.response || {};

  const error = data || axiosError?.data || axiosError;

  if (error && error?.message?.errors?.length) {
    return { code: status || null, message: error.message.errors[0]?.toString() };
  }

  if (error && !error?.message?.errors?.length && error?.errors?.length) {
    return { code: status || null, message: error.errors[0]?.toString() };
  }

  if (error && !error?.message?.errors && error?.message) {
    const message = error.message?.toString();

    if (message === "Card Declined") {
      return { code: status || null, message: "Uh oh - your card on file has been declined. Please update your payment method to proceed." };
    }

    return { code: status || null, message };
  }

  if (error && !error?.message?.errors && !error?.message && error?.code) {
    return { code: status || null, message: `${error.code?.toString()} Something went wrong` };
  }

  if (error && !error?.message?.errors && !error?.message && !error?.code && error?.toString() === "[object Blob]") {
    return { code: status || null, message: "An error occurred while downloading the file" };
  }

  return { code: status || null, message: error?.toString() };
}

